import { Typography } from '@mui/material';
import { toColonTimeFromMs } from 'services/helpers/time';
import useWavesurferContext from 'services/hooks/wavesurfer';
import { DurationContainer } from './styled';

const DurationSection = () => {
  const { song, currentTime } = useWavesurferContext();

  if (!song) {
    return null;
  }

  return (
    <DurationContainer>
      <Typography variant="body1" color="primary">
        {toColonTimeFromMs(currentTime * 1000)}
      </Typography>

      <Typography variant="body1">/</Typography>

      <Typography variant="body1">
        {toColonTimeFromMs(song.duration)}
      </Typography>
    </DurationContainer>
  );
};

export default DurationSection;
